<div class="fixed inset-0 bg-gray-700 bg-opacity-75 flex justify-center items-center z-20 no-scrollbar">
    <div class="bg-white shadow-lg rounded p-4 max-w-md w-full relative">
        <h1 class="font-bold text-xl">{{title}}</h1>
        <p class="mt-1 text-primary-300 text-sm">{{description}}</p>
        <div class="my-4">
            <form [formGroup]="inviteForm">
                <div formArrayName="codes" class="flex flex-row gap-2 justify-center">
                    @for (control of codes.controls; track $index) {
                    <input type="text" maxlength="1"
                        class="w-14 bg-gray-100 text-2xl font-bold border-l-0 border-r-0 border-t-0 border-b-2 border-primary-500 focus:outline-none focus:ring-0 text-center"
                        (input)="onInput($event, $index)" (keydown)="onKeyDown($event, $index)"
                        [formControlName]="$index" autocomplete="off">
                    }

                </div>
                @if(showError) {
                <p class="text-red-500 text-xs mt-2">Please enter a valid invite code.</p>
                }
            </form>
        </div>
        <div class="flex flex-row gap-4 justify-end">
            <button type="button" (click)="onCancel()"
                class="text-primary-500 px-4 py-2 focus:outline-none">Cancel</button>
            <app-btn-submit [isDisabled]="inviteForm.invalid" (click)="submit()"></app-btn-submit>
        </div>
    </div>
</div>